import { render, staticRenderFns } from "./tabMaterialsProduct.vue?vue&type=template&id=51402622&scoped=true&"
import script from "./tabMaterialsProduct.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsProduct.vue?vue&type=script&lang=js&"
import style0 from "./tabMaterialsProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabMaterialsProduct.vue?vue&type=style&index=1&id=51402622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51402622",
  null
  
)

export default component.exports